import { render, staticRenderFns } from "./additionalRequirements.vue?vue&type=template&id=15452bee&"
import script from "./additionalRequirements.vue?vue&type=script&lang=js&"
export * from "./additionalRequirements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports